/* Default Error message for users */
import {ValidationErrors} from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import {UserSession} from './common-structure';
import {User} from '../../services/user/user';
import moment from 'moment';

export const api_error = 'Server busy, please try again';

// User Roles
export const agency_auditor_role = 'Agency Auditor';
export const agency_admin_role = 'Agency Admin';
export const agency_user = 'Agency User';
export const carrier_user = 'TSP User';
export const carrier_user_admin = 'TSP User Admin';
export const carrier_user_RF = 'TSP User RF';
export const system_admin = 'System Admin';
export const duns_url = '/duns';
export const hhg_download_success = 'HHG rates successfully downloaded!';
export const frt_download_success = 'FRT rates successfully downloaded !';
export const frt_shipments_download_success = 'FRT Book Shipments successfully downloaded !';
export const frt_download_template_success = 'FRT template successfully downloaded !';
export const hhg_download_template_success = 'HHG template successfully downloaded !';
export const frt_acc_download_success = 'FRT Accessorials rates successfully downloaded !';
export const file_upload_error = 'File type must be in xlsx format';
export const file_extension_error = 'Please upload xlsx, pdf or image (bmp, jpg, jpeg, png) files!';
export const hhg_iff_download_success = 'HHG IFF shipment summary successfully downloaded !';
export const frt_iff_download_success = 'FRT IFF shipment summary successfully downloaded !';
export const baseURINoPublic = '/tmssserver/api';
export const baseURIPublic = '/tmssserver/api/public';
export const hhg_scope_download_success = 'HHG scope rates report successfully downloaded !';
export const carrier_frt_status_processing= 'Processing';

// Customer Registration Types
export enum CustomerRegistrationType {
  USER = 'User',
  REPORTING_OFFICIAL = 'Authorized Official'
}

// Transportation types
export enum TransportType {
  INTERSTATE = 'Interstate',
  INTRASTATE = 'Intrastate',
  INTERNATIONAL = 'International'
}

export enum TypeOfUser {
  INTERNAL = 'Internal',
  TSP = 'TSP',
  AGENCY = 'Agency'
}

// BUsiness Types
export enum BusinessType {
  HHG = 'HHG',
  FRT = 'FRT',
  HHG_FRT = 'HHG & FRT'
}

export enum UserRecertify {
  DELETED = 'Deleted',
  CERTIFIED = 'Certified'
}

// API Key Type
export enum APIKeyType {
  RateQueryHHG = 'RateQueryHHG',
  RateQueryFRT = 'RateQueryFRT'
}

// api status
export enum APIStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Deleted = 'Deleted'
}

// Customer Registration Status
export enum CustomerRegistrationStatus {
  ACCEPTED = 'Accepted',
  REJECTED = 'Rejected',
  CONFIRM_PENDING = 'Confirm Pending',
  CONFIRMED = 'Confirmed'

  /*ACCEPTED = 'Accepted',
    REJECTED = 'Approval Rejected',
    CONFIRM_PENDING = 'Waiting for Confirmation from User',
    CONFIRMED = 'Confirmed by User and Waiting for Approval'*/
}

// BookShipment Status
export enum BookShipmentStatus {
  INCOMPLETE = 'Incomplete',
  COMPLETE = 'Complete',
  BOOKED = 'Booked',
  PENDING = 'Pending',
  MODIFIED = 'Modified',
  CANCELLED = 'Cancelled',
  ACCEPTED = 'Accepted',
  ACCEPTED_WITH_QUALIFICATION = 'Accepted with Qualification',
  REFUSED = 'Refused',
  EXPIRED = 'Expired'
}

export enum TransportationType {
  DOMESTIC = 'Domestic',
  EXTENDEDSTORAGE = 'Extended Storage',
  INTERNATIONAL = 'International'
}

export enum stateCodes {
  AB = 'AB',
  BC = 'BC',
  LB = 'LB',
  MB = 'MB',
  NB = 'NB',
  NF = 'NF',
  NS = 'NS',
  NT = 'NT',
  ON = 'ON',
  PE = 'PE',
  PQ = 'PQ',
  SK = 'SK',
  YT = 'YT',
  MD = 'MD',
  VA = 'VA',
  DC = 'DC',
  AK = 'AK',
  // contihgous states
  AL = 'AL',
  AZ = 'AZ',
  AR = 'AR',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DE = 'DE',
  FL = 'FL',
  GA = 'GA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  IA = 'IA',
  KS = 'KS',
  KY = 'KY',
  MA = 'MA',
  MI = 'MI',
  MN = 'MN',
  MS = 'MS',
  MO = 'MO',
  MT = 'MT',
  NE = 'NE',
  NV = 'NV',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NY = 'NY',
  NC = 'NC',
  ND = 'ND',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VT = 'VT',
  WA = 'WA',
  WV = 'WV',
  WI = 'WI',
  WY = 'WY',
  LA = 'LA',
  ME = 'ME',
  // alaska state excl codes
  AN = 'AN',
  CV = 'CV',
  FB = 'FB',
  JN = 'JN',
  KN = 'KN',
  KD = 'KD',
  PB = 'PB',
  SA = 'SA',
  WG = 'WG',
  NL = 'NL'
}

export enum SRO {
  FAAIN = 'FAAIN',
  FDICC = 'FDICC',
  FBPMD = 'FBPMD',
  DOSDC = 'DOSDC',
  FAADC = 'FAADC',
  NOAAA = 'NOAAA',
  DOSBG = 'DOSBG',
  DOSHW = 'DOSHW',
  DOSSA = 'DOSSA',
  DOSMM = 'DOSMM',
  NBCCO = 'NBCCO',
  GEOVA = 'GEOVA',
  FSVNM = 'FSVNM',
  NPSNE = 'NPSNE',
  DOSDD = 'DOSDD',
  DEADD = 'DEADD',
  CCNTL = 'CCNTL',
  EXSTG = 'EXSTG',
  XSARC = 'XSARC',
  CONDI = 'CONDI',
  USPDC = 'USPDC',
  OCCDC = 'OCCDC',
  SSADI = 'SSADI',
  ARCWV = 'ARCWV',
  NAVDD = 'NAVDD',
  GSADC = 'GSADC',
  GSADI = 'GSADI',
  DOSUS = 'DOSUS',
  DOSAS = 'DOSAS',
  GENRL = 'GENRL'
}

export enum VehicleType {
  CLASSVEHICLE1 = 'classVehicle1',
  CLASSVEHICLE2 = 'classVehicle2',
  CLASSVEHICLE3 = 'classVehicle3'
}

export enum stateCountry {
  STATE = 'State',
  COUNTRY = 'Country',
  SERVICEAREA = 'Service Area',
  STATECOUNTRY = 'State Country'
}

export enum CarrierApprovalInfo {
  DOMESTICHHG = 'Domestic HHG',
  INTERNATIONALHHG = 'International HHG',
  EXTENDEDSTORAGEHHG = 'Extended Storage HHG'
}

// Name And Address Record Type
export enum NameAndAddressRecordType {
  ORIGIN = 'Origin',
  DESTINATION = 'Destination',
  BILL_TO = 'Bill To',
  SHIPPER = 'Shipper',
  CONSIGNEE = 'Consignee',
  ISSUE_OFFICE = 'Issue Office'
}

// Name And Address Version
export enum NameAndAddressVersion {
  ORIGINAL = 'Original',
  CURRENT = 'Current',
  WORKING = 'Working'
}

// State Country Type
export enum MasterDataAdminType {
  COUNTRY = 'Country',
  COUNTY = 'County',
  SERVICEAREA = 'Service Area',
  FREIGHTSERVICESMASTER = 'Freight Services Master',
  CARRIERRFSPS = 'Rate Filing Service Provider',
  CONTROLKEYS = 'Control Keys',
  DIESELPRICE = 'Diesel Price',
  ZONES = 'Zones',
  CUSTOMERSATISFACTIONINDEX = 'Customer Satisfaction Index',
  CORETSPINDENTIFICATION = 'Core TSP Notification'
}

export enum BondType {
  INTERNATIONALHHG = 'International HHG',
  EXTENDEDSTORAGEHHG = 'Extended Storage HHG',
  DOMESTICHHG = 'Domestic HHG'
}

export enum FrtRqdDocsForRateFiling {
  SCACCERT = 'Certificate of SCAC',
  LIABINSUR = 'Certificate of Liability Insurance',
  TSPAGREEMENT = 'TSP Agreement (which includes the Trading Partner Information Sheet)'
}
// documentTypeList: any = ['UEI # (Sam.gov)', 'Certificate of SCAC', 'Certificate of Liability Insurance', 'EPA Smartway Certifications', 'TSP Agreement (which includes the Trading Partner Information Sheet)',


// Rate Type-LTL, TL
export enum FreightRateType {
  LTL = 'LTL',
  TL = 'TL'
}

// Carrier RFSPS - Shipment Type
export enum ShipmentType {
  IFF = 'IFF',
  RATEFILING = 'RateFiling',
  THIRTYEIGHTY = '3080'
}

// Control Keys Control Type
export enum ControKeysControltype {
  HHGPCMILERVERSION = 'HHG PCMiler Version',
  FRTPCMILERVERSION = 'FRT PCMiler Version',
  CUSTOMERSATISFACTIONINDEX = 'Customer Satisfaction Index',
  FRTRATEFILING = 'FRT Rate Filing'
}

export enum DocumenetStatuses {
  REJECTED = 'Rejected',
  FINALIZED = 'Finalized',
  PENDING_REVIEW = 'Pending Review',
  DELETED = 'Deleted'
}

// US Country Ccode
export const US_STATE_COUNTRY_ID = '326';

export class Actions {
  public actions: String;
  public obj: any;
  public index: number;
  public label: string;

  constructor(actions: string, obj: any, index?, label?) {
    this.actions = actions;
    this.obj = obj;
    this.index = index;
    this.label = label;
  }
}

export class Param {
  lastName: string;
  firstName: string;

  constructor(lastName: string, firstName: string) {
    this.lastName = lastName;
    this.firstName = firstName;
  }
}

function DelindReportStatus(){
  const delindArray = [];
  delindArray.push('Delinquent');
  delindArray.push('Pend/Delinquent');
  delindArray.push('Revoked');
  delindArray.push('Rejected');
  delindArray.push('Not Filed');
  delindArray.push('Not Applicable');
  delindArray.push('Accepted');
  delindArray.push('Completed');
  delindArray.push('Negative');
  return delindArray;
}

function OnlyDenlAndPend(){
  const delindArray = [];
  delindArray.push('Delinquent');
  delindArray.push('Pend/Delinquent');
  return delindArray;
}

function getAllRolesArray() {
  const rolesArray = [];
  rolesArray.push(agency_admin_role);
  rolesArray.push(agency_auditor_role);
  rolesArray.push(agency_user);
  rolesArray.push(carrier_user);
  rolesArray.push(carrier_user_admin);
  rolesArray.push(carrier_user_RF);
  rolesArray.push(system_admin);
  return rolesArray;
}

function getAdminRolesArray() {
  const rolesArray = [];
  rolesArray.push(agency_admin_role);
  rolesArray.push(carrier_user_admin);
  rolesArray.push(system_admin);
  return rolesArray;
}

function getCarrierRolesArray() {
  const rolesArray = [];
  rolesArray.push(carrier_user);
  rolesArray.push(carrier_user_admin);
  rolesArray.push(carrier_user_RF);
  return rolesArray;
}

function isNotNullCondition(object) {
  return (object !== undefined && object !== null && object !== '');
}

function getFormValidationErrors(form) {
  Object.keys(form.controls).forEach(key => {
    const controlErrors: ValidationErrors = form.get(key).errors;
    if (controlErrors != null) {
      Object.keys(controlErrors).forEach(keyError => {
        console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
      });
    }
  });
}

function extractErrorMessagesFromErrorResponse(errorResponse: HttpErrorResponse) {
  // 1 - Create empty array to store errors
  const errors = [];

  // 2 - check if the error object is present in the response
  if (errorResponse.error) {

    // 3 - Push the main error message to the array of errors
    errors.push(errorResponse.error);

    // 4 - Check for  form validation error messages object
    if (errorResponse.error.errors) {

      // 5 - For each error property (which is a form field)
      for (const property in errorResponse.error.errors) {

        if (errorResponse.error.errors.hasOwnProperty(property)) {

          // 6 - Extract it's array of errors
          const propertyErrors: Array<string> = errorResponse.error.errors[property];

          // 7 - Push all errors in the array to the errors array
          propertyErrors.forEach(error => errors.push(error));
        }

      }

    }

  }

  return errors;
}

function constructUserSessionObject(currentUser: User) {
  const userSelected = new UserSession();
  if (isNotNullCondition(currentUser)) {
    userSelected.jSessionId = currentUser.jSessionId;
    userSelected.organizationId = currentUser.organizationId;
    userSelected.userId = currentUser.id;
    userSelected.roleId = currentUser.roles[0].id;
  }
  return userSelected;
}

// this will return roles object based on roleId
function getRoles(roleId) {
  const roleArray = [];
  const roleObj: any = {};
  if (isNotNullCondition(roleId)) {
    switch (roleId) {
      case 1 :
        roleObj.id = roleId;
        roleObj.name = agency_auditor_role;
        roleObj.role = agency_auditor_role;
        break;
      case 2:
        roleObj.id = roleId;
        roleObj.name = agency_admin_role;
        roleObj.role = agency_admin_role;
        break;
      case 3:
        roleObj.id = roleId;
        roleObj.name = agency_user;
        roleObj.role = agency_user;
        break;
      case 4:
        roleObj.id = roleId;
        roleObj.name = carrier_user;
        roleObj.role = carrier_user;
        break;
      case 5:
        roleObj.id = roleId;
        roleObj.name = carrier_user_admin;
        roleObj.role = carrier_user_admin;
        break;
      case 6:
        roleObj.id = roleId;
        roleObj.name = carrier_user_RF;
        roleObj.role = carrier_user_RF;
        break;
      case 7:
        roleObj.id = roleId;
        roleObj.name = system_admin;
        roleObj.role = system_admin;
        break;
    }
    roleArray.push(roleObj);
    return roleArray;
  }
}

function filterSros(isAgencyUser, userRole, sros, agencyMasterId, businessType, viewAllSro, viewAllAgySro, sroType?, agencyId?, agencyCode?) {
  if (businessType === 'HHG') {
    // TODO before any implementation review the agencyMasterId's and agencyId's !!!!important
    if ((sros.some(x => x.sroId === 'CONDI')) && ((agencyMasterId !== 94 && agencyId !== 2941) && (agencyMasterId !== 360 && agencyId !== 1980) && (agencyMasterId !== 1206 && agencyId !== 2131) &&
      (agencyMasterId !== 950 && agencyId !== 2478) && (agencyMasterId !== 367 && agencyId !== 2035)) && userRole !== 'System Admin' && isAgencyUser === true && !viewAllSro) {
      /*    if ((sros.some(x => x.sroId === 'CONDI')) && ((agencyMasterId !== 333 && organizationId !== 230) && (agencyMasterId !== 340 && organizationId !== 230) && (agencyMasterId !== 347 && organizationId !== 230) &&
            (agencyMasterId !== 239 && organizationId !== 230)) && userRole !== 'System Admin' && isAgencyUser === true) {*/
      const index = sros.map(function (x) {
        return x.sroId;
      }).indexOf('CONDI');
      sros.splice(index, 1); // last  removed
    }
    if ((sros.some(x => x.sroId === 'GSADI')) && ((agencyMasterId !== 665 && agencyId !== 3353) && (agencyMasterId !== 945 && agencyId !== 3352) && (agencyMasterId !== 950 && agencyId !== 2495) && (agencyMasterId !== 694 && agencyId !== 2563)) &&
      userRole !== 'System Admin' && isAgencyUser === true) {
      const index = sros.map(function (x) {
        return x.sroId;
      }).indexOf('GSADI');
      sros.splice(index, 1); // last  removed
    }
    if (isAgencyUser === true && userRole !== 'System Admin' && !viewAllSro) {
      if (viewAllAgySro) {
        return sros.filter(sro => {
          if (sro.agencyCode !== null && sro.agencyId !== null) {
            return sro.agencyCode === agencyCode && sro.agencyId === agencyId;
          } else if (sro.agencyCode === null && sro.agencyId === null) {
            return true;
          } else if (sro.agencyCode !== null && sro.agencyId === null) {
            return sro.agencyCode === agencyCode;
          }
        });
      } else {
        return sros.filter(sro => {
          if (sro.agencyMasterId !== null && sro.agencyId !== null) {
            return sro.agencyMasterId === agencyMasterId && sro.agencyId === agencyId;
          } else if (sro.agencyMasterId === null && sro.agencyId === null) {
            return true;
          } else if (sro.agencyMasterId !== null && sro.agencyId === null) {
            return sro.agencyMasterId === agencyMasterId;
          }
        });
      }
    } else {
      return sros;
    }
  }
  if (businessType === 'FRT') {
    if (userRole === 'System Admin' || viewAllSro) {
      return sros;
    } else {
      if ((isAgencyUser === true && userRole !== 'System Admin') || (isAgencyUser === true && sroType === 'Alternating')) {
        return sros.filter(sro => sro.agencyMasterId === agencyMasterId || sro.agencyMasterId === null);
      } else {
        return sros;
      }
    }
  }
}

function generateHours(){
  var listHrs: {key: String, value:String}[] = [];
  for(var i = 0; i < 24; i ++){
    for(var j=0; j< 2; j++){
      var value = ((i<10)? '0' + i.toString() : i.toString()) + ':'+ ( j===0 ? '00' : (j * 30).toString());
      var obj = {key: value, value: value};
      listHrs.push(obj);
    }
  }
  listHrs.push({key:'24:00',value:'24:00'});
  return listHrs;
}

function initCurrentTime(){
  var hr = moment().hour();
  var min = moment().minute();
  var hrMin = ((hr<10)? ('0'+hr.toString()) : hr.toString()) + (( min < 30) ? ':00' : ':30');
  return hrMin
}

// tslint:disable-next-line:max-line-length
export default {
  getAllRolesArray,
  getAdminRolesArray,
  getCarrierRolesArray,
  filterSros,
  isNotNullCondition,
  getFormValidationErrors,
  extractErrorMessagesFromErrorResponse,
  constructUserSessionObject,
  getRoles,
  DelindReportStatus,
  OnlyDenlAndPend,
  generateHours,
  initCurrentTime
};

// socio-indicator
export const SOCI_INDICATOR = [
  {id: '7', scIndicator: 'SBA Certified 8(a) Firm (8a)'},
  {id: '6', scIndicator: 'SBA Certified Small Disadvantaged Business (d)'},
  {id: '5', scIndicator: 'Service Disabled Veteran Owned Small Business (dv)'},
  {id: '8', scIndicator: 'SBA Certified HUBZone Firm (h)'},
  {id: '2', scIndicator: 'Other than Small Business (o)'},
  {id: '1', scIndicator: 'Small Business (s)'},
  {id: '4', scIndicator: 'Veteran Owned Small Business (v)'},
  {id: '3', scIndicator: 'Women Owned Business (w)'}
];

export enum TABLEAU_DASHBOARDS {
  'HHGIFFDashboard' = 'HHG Administrative Fee Dashboard',
  'HHGIFFSummary' = 'HHG Administrative Fee Summary',
  'SITIFFDashboard' = 'SIT Administrative Fee Dashboard',
  'TransitTimes' = 'Transit Times',
  'HHgRateProcStats' = 'HHG Rate Proc Stats',
  '3080Reporting' = '3080 Reporting',
  'TrafficVolume' = 'HHG Traffic Volume',
  'FRTShipmentReport' = 'FRT Shipment Report',
  'FRTShipmentSummary' = 'FRT Shipment Summary',
  'ShipmentMaps' = 'Shipment Maps',
  'RateTrendsLinehaul' = 'HHG Rate Trends',
  'ErrorStats' = 'HHG Rate Filing Error Stats'
}
